import { Component, Input, OnInit } from '@angular/core';
import { IconDefinition } from '@fortawesome/fontawesome-common-types';
import { faQuestionCircle } from '@fortawesome/pro-duotone-svg-icons';

@Component({
   selector: 'samweb-no-value-selected-info',
   templateUrl: './no-value-selected-info.component.html',
   styleUrls: ['./no-value-selected-info.component.scss'],
})
export class NoValueSelectedInfoComponent implements OnInit {
   constructor() {}

   @Input()
   public icon: IconDefinition = faQuestionCircle;

   @Input()
   public textTranslationKey: string;

   ngOnInit(): void {}
}
